// Load the Complete Kit cart upsell (same assets folder as this file).
// Bump UPSELL_VERSION whenever fv-kit-upsell.js changes so browsers fetch the new copy.
(function () {
  var UPSELL_VERSION = '5';
  try {
    var me = document.currentScript;
    if (!me || !me.src || document.getElementById('fv-kit-upsell-js')) return;
    var s = document.createElement('script');
    s.id = 'fv-kit-upsell-js';
    s.defer = true;
    s.src = me.src.split('?')[0].replace('custom-header.js', 'fv-kit-upsell.js') + '?v=' + UPSELL_VERSION;
    document.head.appendChild(s);
  } catch (e) {}
})();

document.addEventListener("DOMContentLoaded", () => {
  const body = document.body;
  const header = document.querySelector(".custom-header");
  const triggers = document.querySelectorAll('[class*="custom-header__link-"]');
  const menus = document.querySelectorAll(
    '[class*="custom-header__mega-menu-"]'
  );
  const mobileMenu = document.querySelector(
    ".custom-header__mobile-menu-wrapper"
  );

  let activeIndex = null;
  let currentTrigger = null;
  let currentMenu = null;
  let hideTimeout = null;

  function adjustMegaMenuOffset(topOffset = 67, isMobile = false) {
    let offset = topOffset;
    if (header) {
      const bottom = header.getBoundingClientRect().bottom;
      if (bottom > 0) offset = bottom;
    }

    if (isMobile) {
      if (mobileMenu) {
        mobileMenu.style.setProperty("--mobile-menu-top", `${offset}px`);
      }
    } else {
      document.documentElement.style.setProperty(
        "--mega-menu-top",
        `${offset}px`
      );
    }
  }

  function adjustAll() {
    adjustMegaMenuOffset(67);
    adjustMegaMenuOffset(60, true);
  }

  adjustAll();
  window.addEventListener("load", adjustAll);
  window.addEventListener("resize", adjustAll);
  window.addEventListener("scroll", adjustAll, { passive: true });

  function showMenu(index, trigger) {
    if (activeIndex === index) return;

    hideAll();

    const menu = document.querySelector(`.custom-header__mega-menu-${index}`);
    if (!menu) return;

    requestAnimationFrame(() => {
      adjustMegaMenuOffset(67);
      trigger.classList.add("active");
      menu.classList.add("active");
      document.body.classList.add("overlay");

      activeIndex = index;
      currentTrigger = trigger;
      currentMenu = menu;
    });
  }

  function hideAll() {
    triggers.forEach((t) => t.classList.remove("active"));
    menus.forEach((m) => m.classList.remove("active"));
    body.classList.remove("overlay");

    activeIndex = null;
    currentTrigger = null;
    currentMenu = null;
  }

  function isCursorOutsideAll(e) {
    const related = e.relatedTarget;
    return !(
      related &&
      ((header && header.contains(related)) ||
        (currentMenu && currentMenu.contains(related)))
    );
  }

  triggers.forEach((trigger) => {
    const index = trigger.className.match(/custom-header__link-(\d+)/)?.[1];
    if (!index) return;

    trigger.addEventListener("mouseenter", () => {
      showMenu(index, trigger);
    });

    trigger.addEventListener("mouseleave", (e) => {
      if (isCursorOutsideAll(e)) {
        scheduleHide();
      }
    });
  });

  menus.forEach((menu) => {
    menu.addEventListener("mouseleave", (e) => {
      if (isCursorOutsideAll(e)) {
        scheduleHide();
      }
    });

    menu.addEventListener("mouseenter", () => {
      clearTimeout(hideTimeout);
    });
  });

  if (header) {
    header.addEventListener("mouseleave", (e) => {
      if (isCursorOutsideAll(e)) {
        scheduleHide();
      }
    });
  }

  function scheduleHide() {
    clearTimeout(hideTimeout);
    hideTimeout = setTimeout(() => {
      const overHeader = header && header.matches(":hover");
      const overMenu = currentMenu && currentMenu.matches(":hover");
      if (!overHeader && !overMenu) {
        hideAll();
      }
    }, 30);
  }

  const headerContent = document.querySelector(".custom-header__content");
  const iconButton = document.querySelector(".custom-header__icon-menu");

  if (iconButton) {
    iconButton.addEventListener("click", () => {
      adjustMegaMenuOffset(60, true);
      headerContent && headerContent.classList.toggle("active");
      iconButton.classList.toggle("active");
      mobileMenu && mobileMenu.classList.toggle("active");
    });
  }
});

document.addEventListener("DOMContentLoaded", () => {
  const menuLinks = document.querySelectorAll(
    '.custom-header__mobile-link[class*="mobile-link-"]'
  );
  const allMenus = document.querySelectorAll(
    ".custom-header__mobile-menu-list"
  );

  let activeMenu = null;

  menuLinks.forEach((link) => {
    link.addEventListener("click", (e) => {
      const classList = Array.from(link.classList);
      const match = classList.find((cls) => cls.startsWith("mobile-link-"));
      if (!match) return;

      const index = match.replace("mobile-link-", "");
      const targetMenu = document.querySelector(`.mobile-menu-${index}`);

      // No sub-menu for this item: let the link open its page as normal.
      if (!targetMenu) return;

      e.preventDefault();

      allMenus.forEach((menu) => menu.classList.remove("active"));

      targetMenu.classList.add("active");
      activeMenu = targetMenu;

      const backText = link.textContent.trim();
      const backBtn = targetMenu.querySelector(".back-link-text");
      if (backBtn) {
        backBtn.innerHTML = `
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path d="M12.5 15L7.5 10L12.5 5" stroke="#221F1C" stroke-opacity="0.25" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          ${backText}`;
      }
    });
  });

  document.querySelectorAll(".back-link-text").forEach((backBtn) => {
    backBtn.addEventListener("click", () => {
      if (activeMenu) {
        activeMenu.classList.remove("active");
        activeMenu = null;
      }
    });
  });
});
